import type { RouteObject } from "react-router-dom";
import { WishlistPage } from "./pages/WishlistPage";

export const wishlistRoutes: RouteObject[] = [
    {
        index: true,
        element: <WishlistPage />,
    },
];
